import Swiper from 'swiper/bundle';

jQuery(document).ready(function () {
    fixedHeaderScroll();
    navMenuMobile();
    toggleHeader();
    scrollTop();
    swiperSlider();
});

function fixedHeaderScroll() {
    let header = $('.main-header');
    let headInfo = $('.head-info');
    let headInfoOffset = headInfo.offset().top + headInfo.outerHeight();
    let navigationMenuMobile = $('.navigation-menu-mobile');


    $(window).scroll(function () {
        // If the mobile navigation menu is not active, apply scroll-based logic
        if (!navigationMenuMobile.hasClass('active')) {
            if ($(window).scrollTop() > headInfoOffset) {
                header.addClass('fixed-header');
            } else {
                header.removeClass('fixed-header');
            }
        }
    });

    // Also ensure the fixed header stays active if the menu is open
    if (navigationMenuMobile.hasClass('active')) {
        header.addClass('fixed-header');
    }
}

function navMenuMobile() {
    const button = jQuery('.burger-menu');
    const navContainer = jQuery('.navigation-menu-mobile');
    const body = jQuery('body');
    const header = jQuery('.main-header');

    button.on('click', function () {
        button.toggleClass('active');
        navContainer.toggleClass('active');

        // Check if the menu is visible
        if (navContainer.hasClass('active')) {
            // Disable scroll when the menu is visible
            body.css('overflow', 'hidden');
            // Show the fixed header when the burger menu is toggled
            header.addClass('fixed-header');
        } else {
            // Enable scroll when the menu is hidden
            body.css('overflow', 'auto');
            // Remove the fixed header when the menu is not active
            header.removeClass('fixed-header');
        }
    });

    jQuery('#menu-main-1 .menu-item-has-children > a').on('click', function (e) {
        e.preventDefault();  // Prevent the default anchor action (if needed)
        const parent = jQuery(this).parent();

        // Toggle the 'open' class on the parent menu item
        parent.toggleClass('open');

        // Show or hide the submenu (slide up/down effect)
        parent.find('.sub-menu').stop(true, true).slideToggle(); // Use stop() to avoid animation queue issues
    });
    // New code to remove .navigation-menu-mobile when menu-item-33 is clicked
    jQuery('#menu-main-1 .menu-item-33').on('click', function () {
        navContainer.removeClass('active');
        body.css('overflow', 'auto');  // Re-enable scrolling
        header.removeClass('fixed-header');  // Remove the fixed header
        button.removeClass('active');  // Optionally close the burger menu
    });
}


function toggleHeader() {
    // Select the menu items with submenus and apply hover effect
    jQuery('#menu-main .menu-item-has-children').hover(
        function () { // Mouse enter on the parent menu item or submenu
            const parent = jQuery(this);

            // Add the 'open' class to the parent menu item
            parent.addClass('open');

            // Show the submenu (slide down effect)
            parent.find('.sub-menu').stop(true, true).slideDown();
        },
        function () { // Mouse leave from the parent menu item or submenu
            const parent = jQuery(this);

            // Remove the 'open' class from the parent menu item
            parent.removeClass('open');

            // Hide the submenu (slide up effect)
            parent.find('.sub-menu').stop(true, true).slideUp();
        }
    );

    // Prevent the submenu from disappearing when clicking on a submenu item
    jQuery('.sub-menu a').on('click', function (e) {
        // This will allow clicks to be processed normally
        e.stopPropagation(); // Prevent the click from propagating to the parent menu item
    });
}


function scrollTop() {
    $(window).scroll(function () {
        if ($(this).scrollTop() > 800) {
            $('.scroll-to-top').addClass('active');
        } else {
            $('.scroll-to-top').removeClass('active');
        }
    });

    $('.scroll-to-top').click(function () {
        $('html, body').animate({scrollTop: 0}, 100);
        return false;
    });
}


function swiperSlider() {
    const swiper = new Swiper('.swiper-container', {
        slidesPerView: 3,
        spaceBetween: 20,
        centeredSlides: true,
        loop: true,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
                centeredSlides: true,
            },
            768: {
                slidesPerView: 3,
                centeredSlides: true,
            },
        },
        on: {
            init() {
                applySlideEffects(this)
            },
            slideChangeTransitionStart() {
                applySlideEffects(this)
            },
        },
    });

    function applySlideEffects(swiper) {
        $(swiper.slides).each(function () {
            const currentSlide = $(this); // Current swiper slide
            const imageWrapper = currentSlide.find('.parallax-image'); // Image container
            const slideImage = imageWrapper.find('img'); // Image element
            const screenWidth = $(window).width(); // Current screen width

            if (screenWidth >= 600) {  // Only apply the effect for screen sizes >= 500px
                if (currentSlide.hasClass('swiper-slide-active')) {
                    // Active slide: responsive scaling and border radius
                    const scaleValue = screenWidth < 500 ? 1.0 : 1.1;
                    const borderRadius = '10px';  // Same border radius for both cases
                    const imageHeight = screenWidth < 500 ? '280px' : '480px';
                    const imageWidth = screenWidth < 500 ? '320px' : '580px';

                    currentSlide.css('transform', `scale(${scaleValue})`);
                    imageWrapper.css({
                        width: imageWidth,
                        height: imageHeight,
                        borderRadius: borderRadius,
                    });
                    slideImage.css({
                        transform: `scale(${scaleValue})`,
                        transition: 'transform 0.6s ease',
                        borderRadius: borderRadius,
                    });
                } else {
                    // Inactive slides: default size and no border radius
                    currentSlide.css('transform', 'scale(0.9)');
                    imageWrapper.css({
                        width: '100%',
                        height: '380px',
                        borderRadius: '10px',
                    });
                    slideImage.css({
                        transform: 'translateX(0) scale(1)',
                        transition: 'transform 0.6s ease',
                        borderRadius: '0px',
                    });
                }
            } else {
                // If screen width is less than 500px, remove the effect entirely
                currentSlide.css('transform', 'scale(1)');
                imageWrapper.css({
                    width: '100%',
                    height: 'auto',
                    borderRadius: '10px',
                });
                slideImage.css({
                    transform: 'scale(1)',
                    transition: 'none',
                    borderRadius: '10px',
                });
            }
        });
    }
}
